import { Component, Inject, inject } from '@angular/core';
import { CognitoService } from 'app/core/http/services/cognito.service';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MaterialDialog } from 'app/modules/shared/components/dialog/dialog.component';
import { DialogData } from 'app/core/interfaces/dialog';

@Component({
  selector: 'app-nova-senha',
  templateUrl: './nova-senha.component.html',
  styleUrls: ['./nova-senha.component.scss'],
})
export class NovaSenhaComponent {
  public form!: FormGroup;
  public invalidEmail: Boolean = true;
  public snackBar: MatSnackBar;
  public submittedCode = false;
  public successSubmited = false;
  public email = '';
  public hide: Boolean = true;

  constructor(
    public dialogRef: MatDialogRef<MaterialDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private cognitoService: CognitoService, 
    private fb: FormBuilder, 
    private router: Router
  ) {
    this.snackBar = inject(MatSnackBar);
  }

  ngOnInit() {
    this.form = this.fb.group({
      newPassword: new FormControl(null, [Validators.required, this.validatePassword]),
      confirmPassword: new FormControl(null, [Validators.required]),
      code: new FormControl('', [Validators.required]),
    },
     { validators: this.matchPassword }
    );
    this.successSubmited = this.data.param.successSubmited;
    this.submittedCode = this.data.param.submittedCode;
    this.email =  this.data.param.email;
  }

  redirectTo(uri: string) {
    this.router.navigateByUrl(uri).then(() => this.openSnackBar('Senha redefinida com sucesso!', 'success'));
  }

  goToUrl(page: string) {
    this.router.navigate([page]); 
  }

  validatePassword(control: AbstractControl): { [key: string]: boolean } | null {
    const password = control.value;
    const hasNumber = /[0-9]/.test(password);
    const hasUpper = /[A-Z]/.test(password);
    const hasLower = /[a-z]/.test(password);
    const hasSpecial = /[^\w\s]/.test(password);

    if (!hasNumber || !hasUpper || !hasLower || !hasSpecial) {
      return { invalidPassword: true };
    }

    return null;
  }

 private getFriendlyErrorMessage(error: any): string {

  if (error?.name) {
    switch (error.name) {
      case 'UserNotFoundException':
        return 'E-mail não encontrado. Verifique e tente novamente.';

      case 'InvalidParameterException':
        return 'Formato de e-mail inválido.';

      case 'LimitExceededException':
        return 'Muitas tentativas realizadas. Tente novamente mais tarde.';

      case 'CodeMismatchException':
        return 'Código de verificação inválido.';

      case 'ExpiredCodeException':
        return 'O código expirou. Solicite um novo código.';

      case 'NotAuthorizedException':
        return 'Usuário desativado. Entre em contato com o suporte.';

      case 'TooManyRequestsException':
        return 'Muitas requisições. Aguarde alguns minutos e tente novamente.';

      case 'InvalidPasswordException':
        return 'A nova senha não atende aos requisitos mínimos.';
    }
  }

  return (
    error?.message ||
    'Ocorreu um erro durante a recuperação da senha. Por favor, tente novamente.'
  );
}


   private matchPassword(AC: AbstractControl) {
    const password = AC.get('newPassword')?.value;
    const confirmPassword = AC.get('confirmPassword')?.value;

    if (password !== confirmPassword) {
      AC.get('confirmPassword')?.setErrors({ mismatch: true });
      return { mismatch: true };
    }

    return null;
  }


  closeModal() {
    this.dialogRef.close();
  }

  confirmNewPassword() {
    const global = this;
    this.cognitoService.resetPassword(this.email, this.form.value.newPassword, this.form.value.code)
      .then(() => {
        global.closeModal();
        global.redirectTo('login');
      })
      .catch((error) => {
       
       this.openSnackBar(this.getFriendlyErrorMessage(error), "error")
      });
  }

  openSnackBar(message: string, status: 'success' | 'error') {
    this.snackBar.open(message, '', {
      duration: 5000,
      panelClass: status == 'success' ? 'snack-success' : 'snack-error',
      horizontalPosition: 'right',
      verticalPosition: 'top',
    });
  }
}
